import React from 'react'
import HybridKekTableComponent from './HybridKeksList'
import { useSelector } from 'react-redux'
import LanguageStrings from '../../../../i18n/locales'
import { type RootState } from '../../../../store'

const HSMConfigurationStrings = LanguageStrings().HSMConfiguration.MainComponent
const HSMConfigurationHybridStrings = LanguageStrings().HSMConfiguration.HybridKek

const MainHybridKeksList = (): JSX.Element => {
  const numOfKeks = useSelector((state: RootState) =>
    state.hybridKekList.hybridKekList?.total_count ?? 0
  )

  return (
    <div>
      <div style={{ marginTop: '20px' }}>
        <div className='configurations-table-heading'>
          <h5 data-testid='schedule-list'>
            {HSMConfigurationHybridStrings.HybridHSMKeksList}{' '}
            <span className='config-list-box'>{numOfKeks} {HSMConfigurationStrings.HybridKeks}</span>
          </h5>
        </div>
        <HybridKekTableComponent />
      </div>
      <br />
    </div>
  )
}
export default MainHybridKeksList
